import { DocumentArrowUpIcon } from "@heroicons/react/20/solid";
import React from "react";
import { EntityActivitySummary } from "./details/entity-activity-summary";
import { EntityActivityEntryProps } from "./types";

export const EntityActivityEntryFileUpload: React.FC<
    EntityActivityEntryProps
> = props => {
    const { activity } = props;
    return (
        <div className="relative flex items-start space-x-3">
            <div className="relative px-1">
                <div className="flex h-8 w-8 items-center justify-center rounded-full bg-gray-100 ring-8 ring-white">
                    <DocumentArrowUpIcon
                        className="h-5 w-5 text-gray-500"
                        aria-hidden="true"
                    />
                </div>
            </div>
            <div className="min-w-0 flex-1 group pt-1">
                <EntityActivitySummary {...props}>added file.</EntityActivitySummary>
                {activity.file ? (
                    <div className="mt-2 text-base text-gray-900">
                        {activity.file.originalFilename}
                    </div>
                ) : null}
            </div>
        </div>
    );
};
